import {
  ballArr,
  count,
  singleDouble,
  singleDoubleCnname,
  smallBig,
  smallBigCnname,
  dragonTiger,
  fishCnname
} from "../../../../helpers/resPatterns";
import dayjs from "dayjs";

const ks = Vue => {
  let list = Vue => {
    return Vue.showMobile
      ? Vue.curKey == "kjhm"
        ? [
            {
              title: "时间",
              align: "center",
              render: (h, { row }) => {
                return <span>{dayjs(row.resultDate).format("HH:mm")}</span>;
              }
            },
            {
              title: "期号",
              align: "center",
              key: "issueId",
              render: (h, { row }) => {
                return (
                  <span>{row.issueId.substring(row.issueId.length - 4)}</span>
                );
              }
            },
            {
              title: "号码",
              align: "center",
              width: "240",
              render: (h, { row }) => {
                return (
                  // <div class="ball num">
                  <div class="ks">
                    {ballArr(row.resultStr).map((x, i) => {
                      return <span class={`c${x}`} />;
                    })}
                  </div>
                );
              }
            }
          ]
        : [
            {
              title: "时间",
              align: "center",
              render: (h, { row }) => {
                return <span>{dayjs(row.resultDate).format("HH:mm")}</span>;
              }
            },
            {
              title: "期号",
              align: "center",
              key: "issueId",
              render: (h, { row }) => {
                return (
                  <span>{row.issueId.substring(row.issueId.length - 4)}</span>
                );
              }
            },
            {
              title: "号码",
              align: "center",
              width: "240",
              render: (h, { row }) => {
                return (
                  // <div class="ball num">
                  <div class="ks">
                    {ballArr(row.resultStr).map((x, i) => {
                      return <span class={`c${x}`} />;
                    })}
                  </div>
                );
              }
            },
            {
              title: "总和",
              align: "center",
              render: (h, { row }) => {
                let arr = ballArr(row.resultStr);
                return (
                  <div class="count">
                    <p class="count brr">{count(arr)}</p>
                  </div>
                );
              }
            },
            {
              title: "单双",
              align: "center",
              render: (h, { row }) => {
                let arr = ballArr(row.resultStr);
                return (
                  <div class="singleDouble">
                    <p>
                      {singleDouble(count(arr)) == 0 ? (
                        <span class="blue">单</span>
                      ) : (
                        <span class="red">双</span>
                      )}
                    </p>
                  </div>
                );
              }
            },
            {
              title: "大小",
              align: "center",
              render: (h, { row }) => {
                let arr = ballArr(row.resultStr);
                return (
                  <div class="smallBig">
                    <p>
                      {smallBig(count(arr), 21) == 0 ? (
                        <span class="blue">小</span>
                      ) : (
                        <span class="red">大</span>
                      )}
                    </p>
                  </div>
                );
              }
            }
          ]
      : [
          {
            title: "时间",
            align: "center",
            render: (h, { row }) => {
              return (
                <span>
                  {dayjs(row.resultDate).format("YYYY-MM-DD HH:mm:ss")}
                </span>
              );
            }
          },
          {
            title: "期数",
            align: "center",
            key: "issueId"
          },
          {
            title: "开奖号码",
            align: "center",
            width: "240",
            render: (h, { row }) => {
              return (
                // <div class="ball num">
                <div class="ks">
                  {ballArr(row.resultStr).map((x, i) => {
                    return <span class={`c${x}`} />;
                  })}
                </div>
              );
            }
          },
          {
            title: "总和",
            align: "center",
            render: (h, { row }) => {
              let arr = ballArr(row.resultStr);
              return (
                <div class="insideTableTd">
                  <p class="count brr">{count(arr)}</p>
                  <p class="singleDouble brr">
                    {singleDouble(count(arr)) == 0 ? (
                      <span class="blue">单</span>
                    ) : (
                      <span class="red">双</span>
                    )}
                  </p>
                  <p class="smallBig">
                    {smallBig(count(arr), 21) == 0 ? (
                      <span class="blue">小</span>
                    ) : (
                      <span class="red">大</span>
                    )}
                  </p>
                </div>
              );
            }
          },
          {
            title: "鱼虾蟹",
            align: "center",
            render: (h, { row }) => {
              let arr = ballArr(row.resultStr);
              let formatColor = x =>
                ({
                  1: "red",
                  2: "green",
                  3: "blue",
                  4: "blue",
                  5: "green",
                  6: "red"
                }[x]);
              return (
                <div class="insideTableTd">
                  {arr.map(x => (
                    <p class={formatColor(x) + " brr"}>{fishCnname[x]}</p>
                  ))}
                </div>
              );
            }
          }
        ];
  };
  return { list };
};
export default ks;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jishikaijiang/columns/ks.js